export default "../../src/img/placeholder.jpeg";